import { successType } from "redux-api-status";
import initialState from "./initialState";
import * as types from "../actions/clientLoginActionTypes";

export default function clientLoginReducer(
  state = initialState.clientLogin,
  action
) {
  switch (action.type) {
    case successType(types.LOAD_CLIENT_PROFILEFROMEMAIL):
      return {
        ...state,
        Profile: action.payload.data,
      };
    default:
      return state;
  }
}
